<template>
      <div class="notifications sm_bar">
        <div class="sm_bar_inner" v-if="smHandles && smHandles.length && isDashboard">
          <span :aria-label="handle.title" v-for="handle in smHandles" :key="handle.title">
            <img :src="handle.icon" @click="take(handle)"></img>
          </span>
        </div>
      </div>
</template>
<script>
import vuex from 'vuex'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'smhandle',
  components: {
  },
  data: () => {
    return {
    smHandles : [],
    isDashboard: false
    }
  },
  async created () {
  	 this.smHandles = await this.loadHandles()
  },
  methods: {
    ...mapActions([
      'loadHandles'
    ]),
    take (hanlde){
      window.open(hanlde.url, '_blank')
    }
	},
  watch: {
    '$route' (to, from) {
        if(!this.smHandles || this.smHandles.length==0){
          this.loadHandles().then(res => {
            this.smHandles = []
            this.smHandles.push(...res)
          })
        }
        if (window.location.href.indexOf('/#/dashboard')!=-1) {
          this.isDashboard = true
        } else {
          this.isDashboard = false
        }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/app/misc/components/Smhandle.vue